import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
import BarcodeComponent from "./barcode_component_controller";

class DynamicButtonComponent extends BridgeComponent {
    static component = "dynamicbutton";

    connect() {
        super.connect();

        const pageType = this.element.dataset.pageType;
        let cartCount = localStorage.getItem("cartCount") || 0;
        if (pageType === "home") {
            if (wkhw_customForm.is_home !== "") {
                history.pushState({}, "", wkhw_customForm.site_url);
            }
            this.send(
                "home",
                {
                    cart: cartCount,
                },
                (response) => {
                    const data = response?.data || {};
                    const type = data?.type; // e.g., "cart", "scan", etc.
                    this.handleAction(type, data);
                },
            );
        }
        if (pageType === "product") {
            this.send("product", { cart: cartCount }, (response) => {
                const data = response?.data || {};
                const type = data?.type; // e.g., "cart", "scan", etc.
                this.handleAction(type, data);
            });
        }

        if (pageType === "share") {
            this.send("share", { cart: cartCount }, (response) => {
                const data = response?.data || {};
                const type = data?.type; // e.g., "cart", "scan", etc.
                this.handleAction(type, data);
            });
        }

        if (pageType === "account") {
            this.send("account", { cart: cartCount }, (response) => {
                const data = response?.data || {};
                const type = data?.type; // e.g., "cart", "scan", etc.
                this.handleAction(type, data);
            });
        }
    }

    handleAction(type, data = {}) {
        const code = data?.code;
        switch (type) {
            case "cart":
                let cartUrl = wkhw_customForm.cart_url;
                window.location.href = cartUrl;
                break;

            case "scan":
                let barcode = new BarcodeComponent();
                barcode.scanAndSearch(code);
                break;

            case "share":
                this.callBridgeComponent("share", "share", { code });
                break;

            case "profile":
                Turbo.visit("/my-account");
                break;

            case "location":
                this.callBridgeComponent("location", "shareLocation", { code });
                break;

            case "theme":
                if (code === "dark") {
                    localStorage.setItem("theme", "dark");
                    document.documentElement.classList.add(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                } else if (code === "light") {
                    localStorage.setItem("theme", "light");
                    document.documentElement.classList.remove(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                } else {
                    localStorage.setItem("theme", "light");
                    document.documentElement.classList.remove(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                }
                break;

            default:
                console.warn(`🚫 Unknown type received: ${type}`);
        }
    }

    callBridgeComponent(componentName, methodName, data = {}) {
        const el = document.querySelector(
            `[data-controller="bridge--${componentName}"]`,
        );
        if (!el) {
            console.error(`❌ Bridge component not found: ${componentName}`);
            return;
        }

        const controller =
            this.application.getControllerForElementAndIdentifier(
                el,
                `bridge--${componentName}`,
            );

        if (controller && typeof controller[methodName] === "function") {
            controller[methodName](data); // ✅ Pass full object
        } else {
            console.error(
                `⚠️ ${methodName} method not found in ${componentName}`,
            );
        }
    }
}
export default DynamicButtonComponent;
